import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { CookiePolicyComponent } from './sites/cookie-policy/cookie-policy.component';
import { FooterComponent } from './components/footer/footer.component';

import './extensions/extension';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { LandingPageComponent } from './sites/landing-page/landing-page.component';
import { TextWithImageComponent } from './components/text-with-image/text-with-image.component';
import { ButtonComponent } from './components/button/button.component';
import { BlankLayoutComponent } from './layouts/blank-layout.component';
import { DefaultLayoutComponent } from './layouts/default-layout.component';
import { BookingPageComponent } from './sites/booking-page/booking-page.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GalleryPageComponent } from './sites/gallery-page/gallery-page.component';
import { AboutUsPageComponent } from './sites/about-us-page/about-us-page.component';
import { RegionPageComponent } from './sites/region-page/region-page.component';

@NgModule({
  declarations: [
    AppComponent,
    BlankLayoutComponent,
    DefaultLayoutComponent,
    LandingPageComponent,
    AboutUsPageComponent,
    RegionPageComponent,
    GalleryPageComponent,
    HeaderComponent,
    FooterComponent,
    CookiePolicyComponent,
    BookingPageComponent,
    PageTitleComponent,
    ButtonComponent,
    TextWithImageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  providers: [
    provideClientHydration(withEventReplay())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
